import { createAsyncThunk, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { GlsTask } from "../../lib/interfaces/GlsTask";
import { LoadingStatusCode } from "../../lib/types/LoadingStatusCode";
import requestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getGlsTasksRoute } from "../../lib/routes/glsTask";

interface InitialState {
  glsTasks: GlsTask[];
  glsTasksLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  glsTasks: [],
  glsTasksLoading: requestStatusCodes.idle,
};

export const getGlsTasks = createAsyncThunk<
  GlsTask[],
  { onDate?: string; glsTypeIds?: number[]; glsStatusIds?: number[] }
>("glsTasks/getGlsTasks", async (params) => {
  const response = axios.get(getGlsTasksRoute(params));
  const { data }: { data: GlsTask[] } = await response;
  return data;
});

export const glsTasksSlice = createSlice({
  name: "glsTasks",
  initialState,
  reducers: {
    resetGlsTasks: (state) => {
      state.glsTasks = [];
      state.glsTasksLoading = requestStatusCodes.idle;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGlsTasks.pending, (state) => {
        state.glsTasksLoading = requestStatusCodes.pending;
      })
      .addCase(getGlsTasks.fulfilled, (state: Draft<any>, action: PayloadAction<GlsTask[]>) => {
        state.glsTasks = action.payload?.sort((a, b) => b.id - a.id);
        state.glsTasksLoading = requestStatusCodes.fulfilled;
      })
      .addCase(getGlsTasks.rejected, (state) => {
        state.glsTasksLoading = requestStatusCodes.rejected;
      });
  },
});

const { reducer, actions } = glsTasksSlice;

const { resetGlsTasks } = actions;

export { reducer, resetGlsTasks };

export default reducer;
